<div class="circle" [style.width]="size + 'px'" [style.height]="size + 'px'">
  <img src="{{ avatarBase64 }}" />
</div>
